// extracted by mini-css-extract-plugin
export default {"parent":"App_parent__X3lco","widgets":"App_widgets__WURs9","aboutButton":"App_aboutButton__VTpM4","hideSection":"App_hideSection__5Av45"};